import axiosInstance from "./AxiosConfig";
import {REST_API_BASE_URL_REMOTE} from '../services/PathEnvironment'

const REST_API_BASE_URL = REST_API_BASE_URL_REMOTE + 'api/nationcountry';

export const listNations = () => axiosInstance.get(REST_API_BASE_URL + '/nations');
export const listCountries = () => axiosInstance.get(REST_API_BASE_URL + '/countries');
